import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Stack, SwipeableDrawer, Tab, Tabs } from "@mui/material";
import React from "react";
import "./common.css";
import CustomButton from "../Form/CustomButton";
import AppDialog from "./AppDialog";
import ReactCrop from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css'
import AppMaskedPlateNumber from "./AppMaskedPlateNumber";
//Import Breadcrumb

const AppEditImage = ({
    open, width, title, close, children, fullWidth = false, contentSx, image, setImage, isMobile = false, mobileSizeModalMaxHeight
}) => {
    const imageRef = React.useRef(null);
    const [tabValue, setTabValue] = React.useState('crop');
    const [confirmDiscardOpen, setConfirmDiscardOpen] = React.useState(false);
    const [completedCrop, setCompletedCrop] = React.useState();
    const [completedMasked, setCompletedMasked] = React.useState();
    const [cropData, setCropData] = React.useState({
        unit: '%', // Can be 'px' or '%'
        x: 5,
        y: 5,
        width: 90,
        height: 90
    });

    const handleConfirmDiscard = () => {
        setConfirmDiscardOpen(true);
    }

    const cropImage = () => {
        if (!completedCrop || !image) {
            return;
        }

        const imageElement = imageRef.current;

        const canvas = document.createElement('canvas');

        const scaleX = imageElement.naturalWidth / imageElement.width;
        const scaleY = imageElement.naturalHeight / imageElement.height;

        canvas.width = completedCrop.width;
        canvas.height = completedCrop.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.drawImage(
            imageElement,
            completedCrop.x * scaleX,
            completedCrop.y * scaleY,
            completedCrop.width * scaleX,
            completedCrop.height * scaleY,
            0,
            0,
            completedCrop.width,
            completedCrop.height
        );

        setImage(canvas.toDataURL('image/jpeg'));
        close();
        setCropData({
            unit: '%', // Can be 'px' or '%'
            x: 5,
            y: 5,
            width: 90,
            height: 90
        })
    };

    const maskedImage = () => {
        setImage(completedMasked ?? image);

        close();
    }

    return (
        <React.Fragment>
            {isMobile ?
                <SwipeableDrawer
                    anchor="bottom"
                    open={open}
                    onOpen={() => ''}
                    onClose={(e) => close()}
                    disableSwipeToOpen={true}
                    sx={{
                        "& .MuiPaper-root": {
                            borderTopLeftRadius: "30px",
                            borderTopRightRadius: "30px",
                            maxHeight: mobileSizeModalMaxHeight,
                        },
                    }}
                >
                    <div className="p-4" style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }}>
                        <div style={{ width: 60, justifySelf: 'center', height: 5, backgroundColor: '#DEDEDE', borderRadius: 50, marginBottom: 20 }}></div>
                        {
                            title &&
                            <div className="my-3 justify-self-center text-semibold font-size-16 text-center">
                                {title}
                                <Divider className="mt-3" />
                            </div>
                        }
                        <Tabs
                            value={tabValue}
                            onChange={(e, val) => (setTabValue(val))}
                            aria-label="basic tabs example"
                            style={{ marginBottom: 20, marginTop: 10 }}
                            TabIndicatorProps={{ style: { backgroundColor: '#1D1B1B' } }}
                        >
                            <Tab
                                key={'crop'}
                                value={'crop'}
                                sx={{ paddingBottom: 0 }}
                                label={
                                    <div className="d-flex" style={{ color: tabValue === 'crop' ? '#1D1B1B' : '#808588', textTransform: 'none' }}>
                                        {'Crop'}
                                    </div>
                                }
                            />
                            <Tab
                                key={'adjust'}
                                value={'adjust'}
                                sx={{ paddingBottom: 0 }}
                                label={
                                    <div className="d-flex" style={{ color: tabValue === 'adjust' ? '#1D1B1B' : '#808588', textTransform: 'none' }}>
                                        {'Mask Number Plate'}
                                    </div>
                                }
                            />
                        </Tabs>
                        <div style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', paddingBottom: 150 }}>
                            {
                                tabValue === 'adjust' &&
                                <AppMaskedPlateNumber
                                    imageData={image}
                                    setImageData={setCompletedMasked}
                                />
                            }
                            {
                                tabValue === 'crop' &&

                                <div className="d-flex justify-content-center" style={{ position: 'relative' }}>
                                    <ReactCrop
                                        crop={cropData}
                                        onChange={(c, percentCrop) => { setCropData(c) }}
                                        onComplete={(c) => setCompletedCrop(c)}
                                        aspect={false}
                                        ruleOfThirds={true}
                                    >
                                        <img ref={imageRef} src={image} style={{ objectFit: 'unset', maxWidth: '100%' }} />
                                    </ReactCrop>
                                    {/* <div style={{position: 'absolute', top: cropData?.y, left: cropData?.x, width: `${cropData?.width}%`, height: `${cropData?.height}%`, border: '1px solid white'}}></div> */}
                                </div>

                            }
                        </div>
                        <div className="position-absolute bottom-0 left-0 p-3" style={{ borderTop: '1px solid #DFDFDF', backgroundColor: 'white', width: '95%' }}>
                            <Stack
                                justifyContent={'center'}
                                direction={"row"}
                                sx={{ width: "100%" }} // Ensure the Stack takes full width
                            >
                                <CustomButton
                                    title={'Cancel'}
                                    press={() => handleConfirmDiscard()}
                                    textColor={'#808588'}
                                    backgroundColor={'#F9F9F9'}
                                    borderStyle={'1px solid #F9F9F9'}
                                    marginRight={10}
                                    width={'100%'}
                                />
                                <CustomButton
                                    title={'Apply changes'}
                                    press={() => { if (tabValue === 'crop') cropImage(); else if (tabValue === 'adjust') maskedImage(); }}
                                    width={'100%'}
                                />
                            </Stack>
                        </div>
                    </div>
                </SwipeableDrawer>
                :
                <Dialog
                    open={open}
                    fullWidth={fullWidth}
                    PaperProps={{
                        sx: {
                            // height: '700px',
                            width: { xs: "100%", sm: width || '70%' },
                            borderRadius: "10px",
                            maxWidth: { xs: "100%", sm: width || '70%' },
                            overflow: 'hidden',
                        }
                    }}
                    onClose={(e) => close()}
                >
                    <DialogTitle style={{ paddingInline: '35px', paddingBlock: '20px' }}>
                        <span style={{ fontSize: "18px", fontWeight: 600 }}>{title}</span>
                        <div className="d-flex align-items-center" style={{ position: 'absolute', right: 30, top: 20 }}>
                            <CustomButton
                                title={'Cancel'}
                                press={() => handleConfirmDiscard()}
                                textColor={'#808588'}
                                backgroundColor={'#F9F9F9'}
                                borderStyle={'1px solid #F9F9F9'}
                                marginRight={10}
                            />
                            <CustomButton
                                title={'Apply changes'}
                                press={() => { if (tabValue === 'crop') cropImage(); else if (tabValue === 'adjust') maskedImage(); }}
                            />
                        </div>
                    </DialogTitle>

                    {/* {title && <Divider className="mb-2" />} */}

                    <DialogContent className="" style={{ paddingInline: '35px', borderRadius: '0 0 15px 15px' }} sx={{ overflowY: 'auto', ...(contentSx || {}) }}>
                        {
                            tabValue === 'adjust' &&
                            <AppMaskedPlateNumber
                                imageData={image}
                                setImageData={setCompletedMasked}
                            />
                        }
                        {
                            tabValue === 'crop' &&
                            <div className="d-flex justify-content-center" style={{ position: 'relative' }}>
                                <ReactCrop
                                    crop={cropData}
                                    onChange={(c, percentCrop) => { setCropData(c) }}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={false}
                                    ruleOfThirds={true}
                                >
                                    <img ref={imageRef} src={image} style={{ objectFit: 'unset', maxWidth: '100%' }} />
                                </ReactCrop>
                                {/* <div style={{position: 'absolute', top: cropData?.y, left: cropData?.x, width: `${cropData?.width}%`, height: `${cropData?.height}%`, border: '1px solid white'}}></div> */}
                            </div>
                        }
                    </DialogContent>
                    <DialogActions style={{ padding: '15px', paddingInline: '30px', justifyContent: 'center' }}>
                        <Tabs
                            value={tabValue}
                            onChange={(e, val) => (setTabValue(val))}
                            aria-label="basic tabs example"
                            style={{ marginBottom: 20, marginTop: 10 }}
                            TabIndicatorProps={{ style: { backgroundColor: '#1D1B1B' } }}
                        >
                            <Tab
                                key={'crop'}
                                value={'crop'}
                                sx={{ paddingBottom: 0 }}
                                label={
                                    <div className="d-flex" style={{ color: tabValue === 'crop' ? '#1D1B1B' : '#808588', textTransform: 'none' }}>
                                        {'Crop'}
                                    </div>
                                }
                            />
                            <Tab
                                key={'adjust'}
                                value={'adjust'}
                                sx={{ paddingBottom: 0 }}
                                label={
                                    <div className="d-flex" style={{ color: tabValue === 'adjust' ? '#1D1B1B' : '#808588', textTransform: 'none' }}>
                                        {'Mask Number Plate'}
                                    </div>
                                }
                            />
                        </Tabs>
                    </DialogActions>
                </Dialog>
            }
            <AppDialog
                open={confirmDiscardOpen}
                close={() => setConfirmDiscardOpen(false)}
                title={'Discard changes?'}
                positiveTitle={'Discard'}
                positivePress={() => { setConfirmDiscardOpen(false); close(); }}
                negativeTitle={'Keep editing'}
                negativePress={() => setConfirmDiscardOpen(false)}
                width={'40%'}
            >
                You will lose your changes if you continue without saving.
            </AppDialog>
        </React.Fragment>
    );
};

export default AppEditImage;